import { Component, Inject } from '@angular/core';
import { PageType } from '../../../../models/admin';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ChangePageTypeDialogData {
  currentPageType: PageType;
}

@Component({
  selector: 'app-change-page-type-dialog',
  standalone: false,
  templateUrl: './change-page-type-dialog.component.html',
  styleUrl: './change-page-type-dialog.component.scss'
})
export class ChangePageTypeDialogComponent {

  pageTypesVals = Object.values(PageType).filter(value => typeof value === 'number');
  pageTypes = this.pageTypesVals.map((type: number) => ({ value: type, label: PageType[type] }));

  selectedPageType: PageType;

  constructor(
    private dialogRef: MatDialogRef<ChangePageTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangePageTypeDialogData
  ) {
    this.selectedPageType = data.currentPageType;
  }
  
  cancel(): void {
    this.dialogRef.close();
  }
  
  save(): void {
    this.dialogRef.close(this.selectedPageType);
  }
}
